
import React from 'react';
import { Button } from "@/components/ui/button";

interface StatusFilterProps {
  statusFilter: 'all' | 'pending' | 'approved' | 'rejected';
  setStatusFilter: (status: 'all' | 'pending' | 'approved' | 'rejected') => void;
}

const StatusFilter = ({ statusFilter, setStatusFilter }: StatusFilterProps) => {
  return (
    <div className="w-full sm:w-auto">
      <div className="grid grid-cols-2 sm:flex gap-2">
        <Button
          variant={statusFilter === "all" ? "default" : "outline"}
          onClick={() => setStatusFilter("all")}
          size="sm"
          className="w-full sm:w-auto"
        >
          All
        </Button>
        <Button
          variant={statusFilter === "pending" ? "default" : "outline"}
          onClick={() => setStatusFilter("pending")}
          size="sm"
          className="w-full sm:w-auto"
        >
          Pending
        </Button>
        <Button
          variant={statusFilter === "approved" ? "default" : "outline"}
          onClick={() => setStatusFilter("approved")}
          size="sm"
          className="w-full sm:w-auto"
        >
          Approved
        </Button>
        <Button
          variant={statusFilter === "rejected" ? "default" : "outline"}
          onClick={() => setStatusFilter("rejected")}
          size="sm"
          className="w-full sm:w-auto"
        >
          Rejected
        </Button>
      </div>
    </div>
  );
};

export default StatusFilter;
